// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jm-1";
export var rowFirst = "_jm-3";
export var rowLast = "_jm-5";
export var rowMiddle = "_jm-4";
export var ticketListScroll = "_jm-2";
export var ticketStack = "_jm-0";